import { Button } from "@mui/material";
import { AiOutlineDownload, AiOutlineEdit } from "react-icons/ai";
import { server } from "../../../common";
import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../../store/stateFunctions";
import { useNavigate } from "react-router-dom";

const Resume = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [profile, setProfile] = useState([]);
  const [profielphoto, setprofilephoto] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getData();
    getProfilePhoto();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/resume/getresume", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Get
  useEffect(() => {
    server
      .get("/register/studentprofile", {
        headers: {
          Authorization: user.authToken,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        setProfile(response.data);
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          navigate("/loginstudent");
        }
        console.log(
          "error",
          error.message,
          error.response?.status,
          error.response?.data,
          error
        );
      });
  }, []);

  // Get
  const getProfilePhoto = () => {
    server
      .get("/register/getallprofile_photo", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setprofilephoto(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    // <div>
    //   <section className="p-3">
    //     <h2 className="text-center mb-4">Resume</h2>
    //     <div className="row">
    //       <div className="col-md-6">
    //         <h3>Student Name </h3>
    //         <p>enquiry@theinnovativesolutions.in</p>
    //         <p>9371001138 </p>
    //         <p>Nashik</p>
    //       </div>
    //       <div className="col-md-6 mt-2">
    //         <h5>
    //           <a href="/" className="text-decoration-none">
    //             <AiOutlineDownload /> Download
    //           </a>
    //         </h5>
    //       </div>
    //     </div>
    //     <hr />
    //     <div>
    //       <div className="container">
    //         <div className="row">
    //           <div className="col-md-4">
    //             <h6>EDUCATION</h6>
    //           </div>
    //           <div className="col-md-4">
    //             <p onClick={handleEducation}>
    //               <IoIosAdd />
    //               Add Education
    //             </p>
    //           </div>
    //         </div>
    //         <hr />

    //         <div className="row">
    //           <div className="col-md-4">
    //             <h6>WORK EXPERIENCE</h6>
    //           </div>
    //           <div className="col-md-2" onClick={handleAddJob}>
    //             <IoIosAdd /> Job Details
    //           </div>
    //           <div className="col-md-2" onClick={handleAddInternship}>
    //             <IoIosAdd />
    //             Internship Details
    //           </div>
    //         </div>
    //         <hr />

    //         <div className="row">
    //           <div className="col-md-4">
    //             <h6>POSITION OF RESPONSIBILITY</h6>
    //           </div>
    //           <div className="col-md-4" onClick={handleAddResponsibility}>
    //             <IoIosAdd />
    //             Add Position Of Responsibility
    //           </div>
    //         </div>
    //         <hr />

    //         <div className="row">
    //           <div className="col-md-4">
    //             <h6>TRAINING / COURSES</h6>
    //           </div>
    //           <div className="col-md-4" onClick={handleAddTraining}>
    //             <IoIosAdd />
    //             Add Training / Courses
    //           </div>
    //         </div>
    //         <hr />

    //         <div className="row">
    //           <div className="col-md-4">
    //             <h6>ACADAMIC / PERSONAL PROJECTS</h6>
    //           </div>
    //           <div className="col-md-4" onClick={handleAddAcadamic}>
    //             <IoIosAdd />
    //             Add Acadamic / Personal Projects
    //           </div>
    //         </div>
    //         <hr />

    //         <div className="row">
    //           <div className="col-md-4">
    //             <h6>SKILLS</h6>
    //           </div>
    //           <div className="col-md-4">
    //             <IoIosAdd />
    //             Add Skills
    //           </div>
    //         </div>
    //         <hr />

    //         <div className="row">
    //           <div className="col-md-4">
    //             <h6>PORTFOLIO/ WORK SAMPLES</h6>
    //           </div>
    //           <div className="col-md-4" onClick={handleAddPortfolio}>
    //             <IoIosAdd />
    //             Add
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </section>

    //   <Modal show={!!modal} onHide={modal?.backBtn}>
    //     <Modal.Header>
    //       <Modal.Title>{modal?.title}</Modal.Title>
    //     </Modal.Header>
    //     {modal?.body && <Modal.Body>{modal.body}</Modal.Body>}
    //     <Modal.Footer>
    //       <Button
    //         variant="contained"
    //         color="secondary"
    //         onClick={modal?.backBtn}
    //       >
    //         Cancel
    //       </Button>
    //       <Button
    //         variant="contained"
    //         className="ms-2"
    //         onClick={modal?.callback}
    //       >
    //         {modal?.btn}
    //       </Button>
    //     </Modal.Footer>
    //   </Modal>
    // </div>
    <>
      <div className="text-end">
        <Button onClick={window.print} variant="contained" className="my-2 ">
          Print
        </Button>
      </div>
      <section className="resume-print">
        <div className="container py-2" style={{ backgroundColor: "#eee" }}>
          <div className="row">
            <div className="col-lg-4">
              <div className="card mb-4" style={{ height: "20rem" }}>
                <div className="card-body text-center">
                  {profielphoto.map((photo) => (
                    <img
                      src={photo.image}
                      className="rounded-circle img-fluid cropped-image"
                      style={{ width: 150 }}
                    />
                  ))}
                  <h5 className="my-3">{profile.name}</h5>
                  <p className=" mb-1">{profile.education}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card mb-1" style={{ height: "20rem" }}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Full Name</p>
                    </div>
                    <div className="col-sm-9">
                      <p className=" mb-0">{profile.name}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Email</p>
                    </div>
                    <div className="col-sm-9">
                      <p className=" mb-0">{profile.email}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Contact </p>
                    </div>
                    <div className="col-sm-9">
                      <p className=" mb-0">{profile.contactno}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">College</p>
                    </div>
                    <div className="col-sm-9">
                      <p className=" mb-0">{profile.college_name}</p>
                    </div>
                  </div>
                  <hr />
                  {/* <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Village</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.village}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Taluka</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.taluka}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">District</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.district}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">State</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.state}</p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="card mb-4 " style={{ color: "#333" }}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3">
                      {data &&
                        data.some(
                          (item) =>
                            item.grad_degree ||
                            item.senior_stream ||
                            item.diploma_stream
                        ) && <p className="mb-0">Education</p>}
                    </div>
                    <div className="col-sm-9">
                      {data &&
                        data?.map((item) => {
                          return (
                            <>
                              {item.grad_degree && (
                                <div>
                                  <h6>
                                    <b>{item.grad_degree}</b>
                                  </h6>
                                  <p>{item.grad_college}</p>
                                  <p>
                                    {item.grad_startdate} - {item.grad_enddate}
                                  </p>
                                </div>
                              )}
                              {item.senior_college && (
                                <div>
                                  <h6>
                                    <b>{item.senior_college}</b>
                                  </h6>
                                  <p>{item.senior_board}</p>
                                  <p>{item.senior_stream}</p>
                                </div>
                              )}
                              {item.diploma_stream && (
                                <div>
                                  <h6>
                                    <b>{item.diploma_stream}</b>
                                  </h6>
                                  <p>{item.diploma_college}</p>
                                  <p>{item.diploma_percentage}</p>
                                </div>
                              )}
                            </>
                          );
                        })}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      {data.some((item) => item.job_designation) && (
                        <p className="mb-0">Work Experience</p>
                      )}
                    </div>
                    <div
                      className="col-sm-9 "
                      style={{ color: "#333 !important" }}
                    >
                      {data &&
                        data?.map((item) => {
                          return (
                            <>
                              <p>
                                {item.job_designation && (
                                  <div>
                                    <h6>
                                      <b>{item.job_designation}</b>
                                    </h6>
                                    <p>{item.job_organisation}</p>
                                    <p>
                                      {item.job_startdate} - {item.job_enddate}
                                    </p>
                                  </div>
                                )}
                                {item.internship_organisation && (
                                  <div>
                                    <b>{item.internship_designation}</b>
                                    <p>{item.internship_organisation}</p>
                                    <p>
                                      {item.internship_startdate} -{" "}
                                      {item.internship_enddate}
                                    </p>
                                  </div>
                                )}
                              </p>
                            </>
                          );
                        })}
                    </div>
                  </div>
                  {data.some((item) => item.job_designation) && <hr />}

                  <div className="row">
                    <div className="col-sm-3">
                      {data &&
                        data.some((item) => item.position_description) && (
                          <p className="mb-0">Position Of Responsibility</p>
                        )}
                    </div>
                    <div className="col-sm-9">
                      <p className="mb-0">
                        {data &&
                          data?.map((item) => {
                            return (
                              <>
                                {item.position_description && (
                                  <div>
                                    <li>{item.position_description}</li>
                                  </div>
                                )}
                              </>
                            );
                          })}
                      </p>
                    </div>
                  </div>
                  {data && data.some((item) => item.position_description) && (
                    <hr />
                  )}

                  <div className="row">
                    <div className="col-sm-3">
                      {data && data.some((item) => item.training_program) && (
                        <p className="mb-0">Training / Courses</p>
                      )}
                    </div>
                    <div className="col-sm-9">
                      <p className=" mb-0">
                        {data &&
                          data?.map((item) => {
                            return (
                              <>
                                {item.training_program && (
                                  <div>
                                    <h6>
                                      <b>{item.training_program}</b>
                                    </h6>
                                    <p>{item.training_organisation}</p>
                                    <p>
                                      {item.training_startdate} -{" "}
                                      {item.training_enddate}
                                    </p>
                                  </div>
                                )}
                              </>
                            );
                          })}
                      </p>
                    </div>
                  </div>
                  {data && data.some((item) => item.training_program) && <hr />}

                  <div className="row">
                    <div className="col-sm-3">
                      {data && data.some((item) => item.project_title) && (
                        <p className="mb-0">Completed Projects</p>
                      )}
                    </div>
                    <div className="col-sm-9">
                      <p className=" mb-0">
                        {data &&
                          data?.map((item) => {
                            return (
                              <>
                                {item.project_title && (
                                  <div>
                                    <h6>
                                      <b>{item.project_title}</b>
                                    </h6>
                                    <p>
                                      {item.project_startdate} -
                                      {item.project_enddate}
                                    </p>
                                    <p>{item.project_description}</p>
                                  </div>
                                )}
                              </>
                            );
                          })}
                      </p>
                    </div>
                  </div>
                  {data && data.some((item) => item.project_title) && <hr />}

                  <div className="row">
                    <div className="col-sm-3">
                      {data && data.some((item) => item.skills) && (
                        <p className="mb-0">Skills</p>
                      )}
                    </div>
                    <div className="col-sm-9">
                      <div className="row">
                        {data &&
                          data?.map((item) => (
                            <>
                              {item.skills && (
                                <div className="col-md-2">
                                  <div className="btn btn-light">
                                    {item.skills}
                                  </div>
                                </div>
                              )}
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                  {data && data.some((item) => item.skills) && <hr />}

                  <div className="row">
                    <div className="col-sm-3">
                      {data && data.some((item) => item.work_github_link) && (
                        <p className="mb-0">Portfolio/Work Samples</p>
                      )}
                    </div>
                    <div className="col-sm-9">
                      {data &&
                        data?.map((item) => {
                          return (
                            <>
                              {item.work_github_link && (
                                <div>
                                  <p>
                                    <a
                                      href={item.work_github_link}
                                      target="_blank"
                                    >
                                      {item.work_github_link}
                                    </a>
                                  </p>

                                  <p>
                                    <a
                                      href={item.work_portfolio_link}
                                      target="_blank"
                                    >
                                      {item.work_portfolio_link}
                                    </a>
                                  </p>
                                </div>
                              )}
                            </>
                          );
                        })}
                    </div>
                  </div>
                  {data && data.some((item) => item.work_github_link) && <hr />}
                </div>
                <p className="text-center">
                  The All Above Information Of This Resume Is Correct If Any
                  Information Found Wrong Then I Am Responsible For Legal
                  Actions Taken By The Company.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Resume;
